import { render, staticRenderFns } from "./Travel.vue?vue&type=template&id=de00d976&scoped=true"
import script from "./Travel.vue?vue&type=script&lang=js"
export * from "./Travel.vue?vue&type=script&lang=js"
import style0 from "./Travel.vue?vue&type=style&index=0&id=de00d976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de00d976",
  null
  
)

export default component.exports